import { Component, OnDestroy, Input, ViewEncapsulation } from '@angular/core';
import { ContactProvider } from './contact.provider';
import { SpinnerProvider } from '../spinner/spinner.provider';
import { Subscription } from 'rxjs';
import { SpinnerComponent } from '../spinner/spinner.component';
import { Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'component-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  providers: [ContactProvider]
})

export class ContactComponent {
  formSubmit: any;
  errorMessage = '';

  constructor(private contact: ContactProvider, private spinner: SpinnerProvider, private router: Router) { }

  submitContact = (form) => {

    if (form.value.captcha === '') {
      form.valid = false;
      return;
    }

    if (form.valid) {
      this.spinner.show();

      const data = {
        FullName: `${ form.value.name } ${ form.value.surname }`,
        Email: form.value.email,
        MobileNo: form.value.prefix + form.value.mobile,
        Message: form.value.message
      };

      this.contact
        .sendContactUsAsync('utils/sendcontactusasync', data)
        .subscribe(
          data => {
            this.spinner.hide();
            if (data && data['isSuccess']) {
              this.router.navigate(['/thankyou']);
            } else {
              this.errorMessage = 'Something went wrong! Please try again later.';
            }
          },
          error => {
            console.log(error);
          }
      );
    }
  }
}
